(() => {
  const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const selectorMap = [
    ['.aureko-hero__copy > *', 'soft'],
    ['.aureko-hero__media', 'media'],
    ['.aureko-story__intro, .aureko-story__text', 'soft'],
    ['.aureko-feature__image, .aureko-lifestyle__media, .aureko-collection__media, .aureko-duo > div:first-child', 'media'],
    ['.aureko-feature__copy, .aureko-lifestyle__panel, .aureko-collection__copy, .aureko-duo__copy, .aureko-faq__title, .aureko-faq__items, .aureko-final__inner', 'soft'],
    ['.aureko-mini-grid > div, .aureko-lifestyle li, .aureko-faq details', 'soft'],
    ['.aureko-guide__intro-copy, .aureko-guide__intro-note, .aureko-guide__group-head, .aureko-guide__recipe, .aureko-bundle-ladder__heading, .aureko-bundle-ladder__cta', 'soft'],
    ['.aureko-tool-guide-card, .aureko-bundle-choice', 'soft'],
    ['.aureko-product-gallery, .aureko-product-story__image, .aureko-product-editorial > img', 'media'],
    ['.aureko-product-info, .aureko-product-story__copy, .aureko-product-method__head, .aureko-product-editorial > div, .aureko-product-description > *, .aureko-product-faq > *', 'soft'],
    ['.aureko-product-method article', 'soft'],
    ['.aureko-cart-heading, .aureko-cart-items, .aureko-cart-benefits, .aureko-cart-value-ladder, .aureko-upsell-card, .aureko-oil-gift-card, .aureko-cart-checkout-card', 'soft'],
    ['.aureko-footer-premium__main > *, .aureko-footer-premium__bottom', 'soft'],
    ['.main-page-title, .rte > *', 'soft']
  ];

  let observer = null;

  const show = (el) => {
    el.classList.add('is-aureko-visible');
    if (observer) observer.unobserve(el);
  };

  const ensureObserver = () => {
    if (observer || reduceMotion || !('IntersectionObserver' in window)) return;
    observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) show(entry.target);
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -7% 0px' });
  };

  const init = (root = document) => {
    const found = [];
    selectorMap.forEach(([selector, kind]) => {
      root.querySelectorAll(selector).forEach((el) => {
        if (el.dataset.aurekoRevealBound === 'true') return;
        if (el.closest('.aureko-confidence-bar, .aureko-mobile-buybar, .aureko-mobile-product-bar')) return;
        el.dataset.aurekoRevealBound = 'true';
        el.dataset.aurekoReveal = kind;
        found.push(el);
      });
    });

    if (!found.length) return;

    found.forEach((el, index) => {
      const parent = el.parentElement;
      const siblings = parent ? Array.from(parent.children).filter((node) => node.matches && node.matches('[data-aureko-reveal]')) : [];
      const localIndex = Math.max(0, siblings.indexOf(el));
      el.style.setProperty('--aureko-reveal-delay', `${Math.min(localIndex * 55, 220)}ms`);
    });

    document.documentElement.classList.add('aureko-reveal-enabled');

    if (reduceMotion || !('IntersectionObserver' in window)) {
      found.forEach(show);
      return;
    }

    ensureObserver();
    requestAnimationFrame(() => {
      found.forEach((el) => {
        const rect = el.getBoundingClientRect();
        if (rect.top < window.innerHeight * 0.92 && rect.bottom > 0) show(el);
        else observer.observe(el);
      });
    });
  };

  const boot = () => init(document);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
